module.exports = __webpack_public_path__ + "static/inlingua-8c9880f1f83cb0814f484bccea966768.svg";